var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { withTheme } from 'styled-components';
import { styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
const animationClassName = 'animation';
// animation possibility here
const StyledFullscreenLayer = styled.div.withConfig({ displayName: "StyledFullscreenLayer", componentId: "sc-1x1y0wp" }) `position:fixed;top:0;right:0;bottom:0;left:0;opacity:1;background-color:${(props) => props.theme.colors.background.primary};transition:${(props) => {
    const duration = props.theme.animation.duration.layer;
    const timingFunction = props.theme.animation.timingFunction.in;
    return `opacity ${duration} ${timingFunction}`;
}};&.${animationClassName}-exit{opacity:1;}&.${animationClassName}-enter,&.${animationClassName}-exit-active,&.${animationClassName}-exit-done{opacity:0;}&.${animationClassName}-enter-active{opacity:1;}`;
StyledFullscreenLayer.displayName = 'StyledFullscreenLayer';
export const InternalFullscreenLayer = (props) => {
    const { active, dialogRole, children, in: visible, onExited } = props, rest = __rest(props, ["active", "dialogRole", "children", "in", "onExited"]);
    const commonProps = getCommonProps(props);
    const handleClick = (event) => {
        const { onClick = () => undefined } = props;
        onClick(event);
    };
    const timeout = parseInt(props.theme.animation.duration.layer || '0', 10);
    return (React.createElement(CSSTransition, { classNames: animationClassName, onExited: onExited, in: visible, timeout: timeout },
        React.createElement(StyledFullscreenLayer, Object.assign({ onClick: handleClick, "aria-modal": active, role: dialogRole }, commonProps, rest), children)));
};
export const FullscreenLayer = withTheme(InternalFullscreenLayer);
